import { BINOptionsCore, EnterpriseFormOptionsCore, IComponentsLibCore, ReviewPageOptionsCore } from "typings/IComponentsLib";
import { HourlyRequestModalsProps } from "./HourlyRequestModals/HourlyRequestModalsProps";
import { HourlyRequestModalType } from "./HourlyRequestModals/HourlyRequestModalType";

/* 
   Check this module for matching the IComponentsLib
   see https://github.com/microsoft/TypeScript/issues/420 
*/
type THIS_MODULE = typeof import("./");
type TYPE_CHECK<T extends IComponentsLibCore> = T;
declare const _: TYPE_CHECK<THIS_MODULE>;

export async function VenueConfirmationBanner() {
   const banner = await import("./VenueConfirmationBanner");
   banner.default();
}

export async function WaitlistModal() {
   const modal = await import("./WaitlistModal");
   modal.default();
}

export async function HourlyRequestCancelModal(requestId: Guid, onCancel: () => void) {
   await hourlyRequestModal({
      requestId,
      modalType: HourlyRequestModalType.Cancel,
      onCancel
   })
}

export async function HourlyRequestDetailsModal(requestId: Guid) {
   await hourlyRequestModal({
      requestId,
      modalType: HourlyRequestModalType.Details
   })
}

const hourlyRequestModal = async (params: HourlyRequestModalsProps) => {
   const modals = await import("./HourlyRequestModals");
   modals.default(params)
}

export async function BIN(opts: BINOptionsCore) {
   const modals = await import("./BookModal");
   modals.default(opts);
}

export async function ReviewPage(options: ReviewPageOptionsCore) {
   const reviewPage = await import("./ReviewPage");
   reviewPage.default(options);
}

export async function EnterpriseForm(props: EnterpriseFormOptionsCore) {
   const form = await import("./EnterpriseForm");
   form.default(props);
}

export async function RegusBookingSyncModal(reservationId: Guid) {
   const modal = await import("./RegusBookingSyncModal");
   modal.default(reservationId);
}

export async function RegusBookingServicesModal(reservationId: Guid) {
   const modal = await import("./RegusBookingServicesModal");
   modal.default(reservationId);
}

export { formatMessage } from "features/EnterprisePortal/Components/Messages/utility";